import React from 'react';

const CustomSnackbarContext = React.createContext(null);

export default CustomSnackbarContext;